module.exports = __webpack_public_path__ + "logo-hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/components/editor/styled/logo-hover.png
// module id = 2123
// module chunks = 0